// actionTypes.js
export const FETCH_BID_HISTORY_REQUEST = 'FETCH_BID_HISTORY_REQUEST';
export const FETCH_BID_HISTORY_SUCCESS = 'FETCH_BID_HISTORY_SUCCESS';
export const FETCH_BID_HISTORY_FAILURE = 'FETCH_BID_HISTORY_FAILURE';

// actionTypes.js
export const VIEW_BID_HISTORY_REQUEST = 'VIEW_BID_HISTORY_REQUEST';
export const VIEW_BID_HISTORY_SUCCESS = 'VIEW_BID_HISTORY_SUCCESS';
export const VIEW_BID_HISTORY_FAILURE = 'VIEW_BID_HISTORY_FAILURE';

export const FETCH_BID_HISTORY_DROPDOWN_REQUEST = 'FETCH_BID_HISTORY_DROPDOWN_REQUEST';
export const FETCH_BID_HISTORY_DROPDOWN_SUCCESS = 'FETCH_BID_HISTORY_DROPDOWN_SUCCESS';
export const FETCH_BID_HISTORY_DROPDOWN_FAILURE = 'FETCH_BID_HISTORY_DROPDOWN_FAILURE';

export const BID_HISTORY_EXPORT = 'BID_HISTORY_EXPORT';
